import React, { useState } from 'react';
import PropTypes from 'prop-types';
// components
import WidgetButtons from './WidgetButtons';
import CustomWidgetCard from './CustomWidgetCard';
// redux
import { useSelector } from '../../redux/store';
// hooks/utils/constants
import { useToggle } from '../../hooks';
import groupedTreatments from '../../utils/groupedTreatments';
import { resolveWidgetTreatments } from '../../utils/widgetTreatmentMatching';
import { widgetArray } from '../../constants/widgetConstants';

const StartedTableReportsWidget = ({ onWidgetClick, dateRangeProps, tableTitle, widgetToggle }) => {
    const { toggle: internalToggle, onOpen, onClose } = useToggle(true);
    const toggle = widgetToggle !== undefined ? widgetToggle : internalToggle;
    const { treatmentsList: { results } } = useSelector((state) => state.practiceTreatment);

    const [currentWidget, setCurrentWidget] = useState('');

    const treatments = groupedTreatments(results);

    const handleOpen = () => onOpen();

    const handleClose = () => onClose();

    const normalizeValues = (value) => (Array.isArray(value) ? value : [value]).filter(Boolean);

    const handleWidgetClick = (value, key) => {
        // Display-only cards (noClick: true) are informational — no table filter applied.
        const card = widgetArray.find((c) => c.key === key);
        if (card?.noClick) return;
        setCurrentWidget(key);
        const values = normalizeValues(value).map((val) => val?.toString?.().toLowerCase?.()).filter(Boolean);
        if (!values.length || values.every((val) => val === '0')) {
            onWidgetClick([]);
            return;
        }
        onWidgetClick(resolveWidgetTreatments(treatments, value));
    };

    return (
        <>
            {dateRangeProps && <WidgetButtons
                toggle={toggle}
                dateRangeProps={dateRangeProps}
                handleOpen={handleOpen}
                handleClose={handleClose}
                tableTitle={tableTitle}
            />}
            {toggle && tableTitle !== 'Aligner Approve Leads' && (
                <CustomWidgetCard handleWidgetClick={handleWidgetClick} widgetArray={widgetArray} currentWidget={currentWidget} type="treatmentStarted"/>
            )}
        </>
    );
};

export default StartedTableReportsWidget;

StartedTableReportsWidget.propTypes = {
    onWidgetClick: PropTypes.func,
    dateRangeProps: PropTypes.object,
    tableTitle: PropTypes.string,
    widgetToggle: PropTypes.bool,
};
